export default __webpack_public_path__ + "static/media/bkg--masterplan.53634657.jpg";